"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const product_entity_1 = require("../products/product.entity");
const product_category_entity_1 = require("../products/product-category.entity");
const inventory_stock_entity_1 = require("../inventory/inventory-stock.entity");
let ProductsService = class ProductsService {
    constructor(productRepo, categoryRepo, stockRepo) {
        this.productRepo = productRepo;
        this.categoryRepo = categoryRepo;
        this.stockRepo = stockRepo;
    }
    findAll() {
        return this.productRepo.find({
            where: { isActive: true },
            relations: ['stockLocations', 'categories'],
            order: { name: 'ASC' },
        });
    }
    async findById(id) {
        const product = await this.productRepo.findOne({
            where: { id },
            relations: ['stockLocations', 'categories'],
        });
        if (!product)
            throw new common_1.NotFoundException(`Product #${id} not found`);
        return product;
    }
    async search(q) {
        const products = await this.productRepo.find({
            where: [
                { name: (0, typeorm_2.ILike)(`%${q}%`), isActive: true },
                { sku: (0, typeorm_2.ILike)(`%${q}%`), isActive: true },
                { category: (0, typeorm_2.ILike)(`%${q}%`), isActive: true },
            ],
            relations: ['stockLocations', 'categories'],
            order: { name: 'ASC' },
        });
        const matchedByRelation = await this.productRepo
            .createQueryBuilder('product')
            .leftJoinAndSelect('product.stockLocations', 'stockLocations')
            .leftJoinAndSelect('product.categories', 'categories')
            .where('product.isActive = :isActive', { isActive: true })
            .andWhere('LOWER(categories.name) LIKE LOWER(:query)', { query: `%${q}%` })
            .orderBy('product.name', 'ASC')
            .getMany();
        return this.dedupeProducts([...products, ...matchedByRelation]);
    }
    async listCategories() {
        return this.categoryRepo.find({ order: { name: 'ASC' } });
    }
    async create(dto) {
        const categoryNames = this.normalizeCategoryNames(dto.categories, dto.category);
        const categories = await this.resolveCategories(categoryNames);
        const product = this.productRepo.create({
            ...dto,
            category: categoryNames[0] ?? dto.category ?? null,
            categories,
        });
        const saved = await this.productRepo.save(product);
        return this.findById(saved.id);
    }
    async update(id, dto) {
        const product = await this.findById(id);
        const categoryNames = this.normalizeCategoryNames(dto.categories, dto.category ?? product.category);
        const categories = await this.resolveCategories(categoryNames);
        Object.assign(product, {
            ...dto,
            category: categoryNames[0] ?? null,
            categories,
        });
        await this.productRepo.save(product);
        return this.findById(id);
    }
    normalizeCategoryNames(categoryNames, primaryCategory) {
        const normalized = [...(categoryNames ?? []), primaryCategory ?? '']
            .map((value) => `${value ?? ''}`.trim())
            .filter(Boolean);
        return [...new Set(normalized)];
    }
    async resolveCategories(names) {
        const uniqueNames = [...new Set(names)];
        if (!uniqueNames.length)
            return [];
        const existing = await this.categoryRepo.find({
            where: uniqueNames.map((name) => ({ name })),
        });
        const existingByName = new Map(existing.map((category) => [category.name, category]));
        const missingNames = uniqueNames.filter((name) => !existingByName.has(name));
        if (missingNames.length) {
            const created = await this.categoryRepo.save(missingNames.map((name) => this.categoryRepo.create({ name })));
            for (const category of created) {
                existingByName.set(category.name, category);
            }
        }
        return uniqueNames
            .map((name) => existingByName.get(name))
            .filter((category) => Boolean(category));
    }
    dedupeProducts(products) {
        const seen = new Set();
        return products.filter((product) => {
            if (seen.has(product.id))
                return false;
            seen.add(product.id);
            return true;
        });
    }
};
exports.ProductsService = ProductsService;
exports.ProductsService = ProductsService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(product_entity_1.Product)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(product_category_entity_1.ProductCategory)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(inventory_stock_entity_1.InventoryStock)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object])
], ProductsService);
